var e = { exports: {} };
export {
  e as r
};
//# sourceMappingURL=react-responsive.js.map
